// import './DemoApp.scss';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Scroll, { animateScroll, Events } from 'react-scroll';

import * as UploadActions from '../../actions/UploadActions';
import * as DemoImageActions from '../../actions/DemoImageActions';
import * as SampleActions from '../../actions/SampleActions';
import * as SectionNavActions from '../../actions/SectionNavActions';
import { UploadPanel, UploadResult, PromoBlock, OptimizationPanel, DeliveryPanel, ImplementationsPanel, Dialog, HeaderView, FooterView } from '../../components';
import { applicationModes, applicationRoutes, sections } from '../../constants';
import * as Munchkin from '../../core/munchkin';

import MultiCdn from '../../components/MultiCdn/MultiCdn';

const SCROLL_EVENT_BEGIN = 'begin';
class DemoApp extends Component {
  constructor(props, context) {
    super(props, context);
    this.setCurrentImage = this.setCurrentImage.bind(this);
  }

  componentDidMount() {
    Events.scrollEvent.register(SCROLL_EVENT_BEGIN, (to, element) => {
      this.props.sectionNavActions.setCurrentSection(null);
    });

    if (this.props.route && this.props.route.path) {
      if (this.props.route.setApplicationMode) {
        this.props.route.setApplicationMode();
      }
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.currentSection && nextProps.currentSection != this.props.currentSection) {
      this.scrollToSection(nextProps.currentSection);
    }
  }

  componentWillUnmount() {
    Events.scrollEvent.remove(SCROLL_EVENT_BEGIN);
  }

  scrollToSection(sectionName) {
    Scroll.scroller.scrollTo(sectionName, {
      duration: 1500,
      delay: 100,
      smooth: true,
      offset: -70
    });
  }

  setCurrentImage(resourceInfo) {
    this.props.uploadActions.setCurrentImage(resourceInfo);
    this.props.sectionNavActions.setCurrentSection(sections.UPLOAD_RESULTS);
  }

  setCanonicalRel(module) {
    const rel = document.querySelectorAll('link[rel="canonical"]')[0];
    const location = document.location;
    const href = `${location.protocol}//${location.host}/${module}`;
    rel.setAttribute('href', href);
  }

  render() {
    const { currentImage, actions, uploadActions, sampleActions, sectionNavActions, imageDetails, demoImages, sampleLang, applicationMode } = this.props;
    let publicId;
    let transformation, format, details, dialogImageSize, dialogImageWidth, dialogImageHeight;
    let hideUpload = false;
    publicId = currentImage.public_id;

    if (imageDetails) {
      transformation = imageDetails.transformation;
      format = imageDetails.format;
      details = imageDetails.details;
    }
    if (demoImages && demoImages.dialogImage) {
      dialogImageSize = demoImages.dialogImage.size;
      dialogImageWidth = demoImages.dialogImage.width;
      dialogImageHeight = demoImages.dialogImage.height;
    }

    let contentElement;
    if (this.props.applicationMode === applicationModes.G_AUTO) {
      this.setCanonicalRel(applicationRoutes.G_AUTO);
      contentElement = (
        <div>
          <UploadResult {...this.props} currentImage={currentImage} />
        </div>
      );
    } else if (this.props.applicationMode === applicationModes.Q_AUTO) {
      this.setCanonicalRel(applicationRoutes.Q_AUTO);
      contentElement = (
        <div>
          <OptimizationPanel actions={actions} publicId={publicId} applicationMode={applicationMode} />
        </div>
      );
    } else if (this.props.applicationMode === applicationModes.MULTI_CDN) {
      hideUpload = true;
      this.setCanonicalRel(applicationRoutes.MULTI_CDN);
      contentElement = (
        <div>
          <MultiCdn {...this.props} currentImage={currentImage} />
        </div>
      );
    } else {
      //default
      this.setCanonicalRel(applicationRoutes.DEFAULT);
      contentElement = (
        <div>
          <UploadResult {...this.props} currentImage={currentImage} />
          <DeliveryPanel publicId={publicId} setSampleLang={sampleActions.setSampleLang} lang={sampleLang} />
          <OptimizationPanel actions={actions} publicId={publicId} applicationMode={applicationMode} />
          <ImplementationsPanel {...this.props}
            publicId={publicId}
            reportImageSize={actions.reportImageSize}
            showDetails={actions.showDetails}
            setCurrentSection={sectionNavActions.setCurrentSection} />
        </div>
      );
    }

    return (
      <div id="wrapper">
        <HeaderView actions={actions} setCurrentImage={this.setCurrentImage} hiddenUpload={!publicId || hideUpload} />
        <main id="main" role="main">
          <UploadPanel hidden={publicId} setCurrentImage={this.setCurrentImage} applicationMode={applicationMode} />

          <Scroll.Element name={sections.UPLOAD_RESULTS} />
          {contentElement}
          <PromoBlock />
        </main>
        <FooterView />
        <Dialog publicId={publicId}
          transformation={transformation}
          format={format}
          details={details}
          showDetails={actions.showDetails}
          reportImageSize={actions.reportImageSize}
          reportImageDimensions={actions.reportImageDimensions}
          resetDemoImage={actions.resetDemoImage}
          setSampleLang={sampleActions.setSampleLang}
          size={dialogImageSize}
          width={dialogImageWidth}
          height={dialogImageHeight}
          lang={sampleLang} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentImage: state.currentImage,
    imageDetails: state.imageDetails,
    demoImages: state.demoImages,
    sampleLang: state.sampleLang,
    currentSection: state.currentSection,
    applicationMode: state.applicationMode
  };
}

function mapDispatchToProps(dispatch) {
  return {
    uploadActions: bindActionCreators(UploadActions, dispatch),
    actions: bindActionCreators(DemoImageActions, dispatch),
    sampleActions: bindActionCreators(SampleActions, dispatch),
    sectionNavActions: bindActionCreators(SectionNavActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DemoApp);



/** WEBPACK FOOTER **
 ** ./src/js/containers/DemoApp/DemoApp.js
 **/